<div *ngIf="truncate && firstAppliedTag"
     class="highlighted-topline highlighted-topline--tags">
  <span class="color--gray">
    {{tagCategoryName}}
  </span>
  <strong class="color--gray--005 txt-fw-500"
          [matTooltip]="getHighlightedTooltip()">
    {{firstAppliedTag.tag.name}}
    <ng-container *ngIf="attachmentsEnabled">
      <app-attachment-button (click)="preventDefault($event)"
                             *ngIf="!!firstAppliedTag.attachments?.length"
                             [attachment]="firstAppliedTag.attachments[0]">
      </app-attachment-button>
    </ng-container>
  </strong>
</div>

<ng-container *ngIf="!truncate">
  <div class="toplines__pair toplines__pair--tags col__ flexAlign--baseline">
    <div class="pair__icon">
      <i class="fal fa-fw fa-tags"
         matTooltip="{{tagCategoryName}}"></i>
      <span class="screen-reader">{{tagCategoryName}}</span>
    </div>
    <div class="pair__content">
      <div class="flag__card">
        <div class="toplines__heading flex flexAlign-center pl-0050 mb-0"
             [ngStyle]="!firstAppliedTag ? { 'margin-bottom': 0 } : null">
          <div class="toplines__heading--content">
            {{tagCategoryName}}
          </div>
          <div class="toplines__heading--action-btn ml-auto mr-0075"
               *appIfOrAdmin="!tagCategory?.readonly">
            <button mat-button
                    type="button"
                    aria-label="Add response for field {{tagCategoryName}}"
                    disableRipple
                    class="addNew mat-button--no-focus-overlay slim"
                    (click)="onAddClicked()">
              <i class="far fa-plus"></i>
            </button>
          </div>

        </div>
        <!-- hidden -->
        <span class="pair__label"
              *ngIf="topline.appliedToplineValue?.appliedTags?.length > 0">{{tagCategoryName}}</span>
        <div class="flag"
             *ngFor="let et of topline.appliedToplineValue?.appliedTags"
             [ngClass]="{
               'flag--address': et.tag.tagType === 'Address',
               'flag--note': et.tag.tagType === 'Notes' || et.tag.tagType === 'Date' || et.tag.tagType === 'Number'
              }">
          <span class="flag__title">{{tagCategoryName}}</span>
          <span class="flag__main">
            {{et.tag.name}}
            <ng-container *ngIf="attachmentsEnabled">
              <app-attachment-button *ngIf="!!et.attachments?.length"
                                     [attachment]="et.attachments[0]">
              </app-attachment-button>
            </ng-container>
          </span>
          <ng-container *ngIf="et.tag.tagType === 'Address'">
            <full-address [address]="et.tag.address"></full-address>
          </ng-container>
          <ng-container *ngIf="et.tag.tagType === 'Notes'">
            <span class="flag__note w-100"
                  *ngFor="let note of et.notes">
              <app-clipped-note [text]="note.text"
                                class="d-block mt-0025">
              </app-clipped-note>
            </span>
          </ng-container>
          <ng-container *ngIf="et.tag.tagType === 'Date'">
            <span class="flag__note"
                  *ngFor="let note of et.notes">{{note.text|date:shortDate}}</span>
          </ng-container>
          <ng-container *ngIf="et.tag.tagType === 'Number'">
            <span class="flag__note"
                  *ngFor="let note of et.notes">{{note.text|number}}</span>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>
